import {API} from '@/lib/utils/api.utils';
import {ScriptLoadErrorPayload} from '@/types/error.types';

const SCRIPT_LOAD_ERROR_LOG_ENDPOINT = '/log/script-load-error';

/**
 * Builds and sends a script load error payload. Safe to call from Next.js Script onError or
 * from global error handlers; does not throw.
 */
export function sendScriptLoadErrorReport(e: Event): void {
	// This should never happen, but just in case.
	if (!(e?.target instanceof HTMLScriptElement)) {
		return;
	}

	const script = e.target;
	const src = script.src || script.getAttribute('src');
	if (!src) return;

	const payload: ScriptLoadErrorPayload = {
		scriptURL: src,
		documentURI: typeof document !== 'undefined' ? document.location.href : '',
		async: script.async,
		defer: script.defer
	};

	if (process.env.NODE_ENV === 'development') {
		console.warn('[Script load error]', payload);
	}

	API.post<void>(SCRIPT_LOAD_ERROR_LOG_ENDPOINT, payload).catch(() => {});
}
